import { useRef, useState } from "react";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Services from "@/components/site/Services";
import Partners from "@/components/site/Partners";
import RCACalculator from "@/components/site/RCACalculator";
import HowItWorks from "@/components/site/HowItWorks";
import About from "@/components/site/About";
import FAQ from "@/components/site/FAQ";
import ContactSection from "@/components/site/ContactSection";
import Footer from "@/components/site/Footer";
import FloatingCall from "@/components/site/FloatingCall";

export default function Landing() {
    const contactRef = useRef(null);
    const [presetProduct, setPresetProduct] = useState("");

    const scrollToContact = (product) => {
        if (product) setPresetProduct(product);
        contactRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    return (
        <div className="min-h-screen bg-[#fcfbf8]">
            <Header onCtaClick={() => scrollToContact()} />
            <main>
                <Hero onCtaClick={() => scrollToContact()} />
                <Services onSelect={(p) => scrollToContact(p)} />
                <Partners />
                <RCACalculator />
                <HowItWorks />
                <About />
                <FAQ />
                <ContactSection ref={contactRef} presetProduct={presetProduct} />
            </main>
            <Footer />
            <FloatingCall />
        </div>
    );
}
